import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { CompanyLevelContentParamsProps } from "../shared/types";

const useStyles = () => {
    const { blue700, gray300 } = colors;

    const getCompanyLevelDesktopCSS = (
        params: CompanyLevelContentParamsProps,
        isLast: boolean,
        isInfo: boolean
    ) => {
        const { isTitle, paddingBottom } = params;

        const textCSS = {
            fontWeight: isTitle ? "600" : "400",
            fontSize: isTitle ? "24px" : "16px",
            lineHeight: isTitle ? "32px" : "24px",
            letterSpacing: isTitle ? "0" : "0.15px"
        };

        const alignmentCSS = {
            display: "flex",
            paddingBottom,
            paddingRight: isLast ? "initial" : "8px",
            paddingLeft: !isInfo ? "8px" : "unset",
            alignItems: "center",
            "& span": {
                flex: "1"
            }
        };

        const iconCSS = {
            "& div, span": {
                marginLeft: "auto",
                display: "flex",

                "& > svg": {
                    fontSize: "16px",
                    color: blue700
                }
            }
        };

        return [textCSS, alignmentCSS, iconCSS];
    };

    const getCompanyLevelMobileCSS = (
        params: CompanyLevelContentParamsProps,
        isInfo: boolean
    ) => {
        const { isTitle } = params;

        const textCSS = {
            fontWeight: isTitle ? "600" : "400",
            fontSize: isTitle ? "20px" : "16px",
            lineHeight: isTitle ? "24px" : "20px",
            letterSpacing: "0.15px"
        };

        const alignmentCSS = {
            display: "flex",
            padding: isTitle ? "16px 24px" : "14px 24px",
            justifyContent: isInfo ? "flex-start" : "flex-end",
            alignItems: "center"
        };

        const iconCSS = {
            "& div, span": {
                display: "flex",
                "& > svg": {
                    fontSize: "16px",
                    color: blue700
                }
            }
        };

        return [textCSS, alignmentCSS, iconCSS];
    };

    const getGridItemCSS = (
        isLast: boolean,
        isHeader: boolean,
        isInfo?: boolean
    ) => {
        return css([
            {
                padding: isInfo ? "0 16px 0 8px" : "0 8px",
                textAlign: isInfo ? "unset" : "center",
                borderRight: isLast ? "none" : `1px solid ${gray300}`,

                display: isInfo ? "initial" : "flex"
            },
            !isHeader && {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center"
            }
        ]);
    };

    return {
        getCompanyLevelDesktopCSS,
        getCompanyLevelMobileCSS,
        getGridItemCSS
    };
};

export { useStyles };
